import { render } from "./onboarding-verification.vue?vue&type=template&id=ac794bca"
import script from "./onboarding-verification.vue?vue&type=script&lang=js"
export * from "./onboarding-verification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__